import axios from './_inveAxios'

export const actualizarFechasMasivo = data => axios.post('/facturaciones/actualizar-fechas-masivo', data)